import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_NEWS = "SHOP:UPSERT_NEWS";

export const upsertNewsAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string,
  productImage?: File
) => ({
  type: UPSERT_NEWS as typeof UPSERT_NEWS,
  organization,
  data,
  id,
  productImage,
});

export type UpsertNewsAction = ReturnType<typeof upsertNewsAction>;
